import { defineComponent as _defineComponent } from 'vue'

enum ColorScheme {
  Text100 = 'Text100',
  Text200 = 'Text200',
  Text300 = 'Text300',
}

enum SizePreset {
  W48px = 'W48px',
  W64px = 'W64px',
  W96px = 'W96px',
  W128px = 'W128px',
  W160px = 'W160px',
}

export { OzBaseButtonHrefMode as OzPadletLogoHrefMode } from 'library/v4/components/OzBaseButton.vue'
export { ColorScheme as OzPadletLogoColorScheme, SizePreset as OzPadletLogoSizePreset }
const __default__ = {}

import { NATIVE_HOST } from 'bits/url'
import { OzBaseButtonHrefMode } from 'library/v4/components/OzBaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzPadletLogo',
  props: {
    darkMode: { type: [String, Boolean], default: 'auto' },
    href: { default: `https://${NATIVE_HOST}` },
    colorScheme: { default: ColorScheme.Text100 },
    sizePreset: { default: SizePreset.W64px },
    hrefMode: { default: OzBaseButtonHrefMode.Default },
    xCraneIcon: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { darkMode: 'auto' | boolean, href: string, colorScheme: ColorScheme, sizePreset: SizePreset, hrefMode: OzBaseButtonHrefMode, xCraneIcon: boolean }





function click(event: MouseEvent): void {
  if (props.hrefMode !== OzBaseButtonHrefMode.Default) event.preventDefault()
  if (props.hrefMode === OzBaseButtonHrefMode.HistoryPushState) {
    // Store the url in the history state so you can read it later
    window?.history?.pushState({ url: props.href }, '', props.href)
  }

  /**
   * Click event
   * @property {MouseEvent} event click event
   */
  emit('click', event)
}

return { __sfc: true,ColorScheme, SizePreset, props, emit, click }
}

})